// src/stage2/props/AnimatedGate.jsx
import React, { useRef, useEffect } from 'react';
import { useGLTF, useAnimations } from '@react-three/drei';
import * as THREE from 'three';

const GATE_URL = '/stageAssets/stage2/scene/Stage2Exterior-ChainGateDoor.glb';

export function AnimatedGate({ open = false, ...props }) {
  const group = useRef();

  // Load model + animations
  const { scene, animations } = useGLTF(GATE_URL);
  const { actions, names } = useAnimations(animations, group);

  useEffect(() => {
    if (!names.length) return;

    // If you know the exact clip name, replace names[0] with 'GateOpen' or whatever
    const clipName = names[0];
    const action = actions[clipName];
    if (!action) return;

    action.clampWhenFinished = true;       // stay at last frame
    action.loop = THREE.LoopOnce;

    if (open) {
      // Play from start
      action.reset().play();
    } else {
      // Go back to closed pose (frame 0)
      action.stop();
      action.reset();
    }
  }, [open, actions, names]);

  return (
    <group ref={group} {...props}>
      <primitive object={scene} />
    </group>
  );
}

useGLTF.preload(GATE_URL);
